var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-tabs',{attrs:{"background-color":"appBackground darken-1","align-with-title":""}},_vm._l((_vm.items),function(item,index){return _c('v-tab',{key:index,attrs:{"to":item.to,"active-class":"selected-color","exact":""}},[_vm._v(" "+_vm._s(_vm.$t(item.name))+" ")])}),1),_c('v-container',{staticClass:"pt-0"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }